import Prompt from './main'
const commonDiamondPrompt = {
  install:function(Vue) {
    Vue.component('commonDiamondPrompt', Prompt)
  }
}
// 导出该组件
export default commonDiamondPrompt